export const translation = {
    channel: 'Slack Channel',
    channelValidationError: {
        invalid: 'The Slack channel name is invalid.',
        tooLong: 'The Slack channel name is too long.'
    },
    selectOrCreateChannel: 'Select or create channel',
    section: {
        title: 'Slack Notifications',
        description: 'Get notified when a table is materialized in Snowflake'
    }
};
